<template>
  <footer class="site-footer">
    <div class="container site-footer-grid">
      <div class="site-footer-brand">
        <BrandMark :compact="true" />
        <p class="site-footer-tag muted">{{ SITE.tagline }}</p>
        <p class="muted small">
          Charts, AI signals, liquidation heatmaps, and forecast — in one pro terminal.
        </p>
      </div>

      <div class="site-footer-cols">
        <div>
          <h4>Product</h4>
          <ul>
            <li><RouterLink :to="{ path: '/', hash: '#features' }">Features</RouterLink></li>
            <li><RouterLink :to="{ path: '/', hash: '#pricing' }">Pricing</RouterLink></li>
            <li><RouterLink :to="{ path: '/', hash: '#faq' }">FAQ</RouterLink></li>
            <li><RouterLink to="/features">Feature details</RouterLink></li>
          </ul>
        </div>
        <div>
          <h4>Account</h4>
          <ul>
            <li><SmartCta mode="login" variant="link" label="Login" class="footer-link" /></li>
            <li><SmartCta variant="link" label="Sign up free" class="footer-link" /></li>
            <li><a :href="FORGOT_PASSWORD_URL" class="footer-link">Forgot password</a></li>
            <li><SmartCta mode="dashboard" variant="link" label="Open app" class="footer-link" /></li>
          </ul>
        </div>
        <div>
          <h4>Legal</h4>
          <ul>
            <li><RouterLink to="/legal#imprint">Imprint</RouterLink></li>
            <li><RouterLink to="/legal#privacy">Privacy</RouterLink></li>
            <li><RouterLink to="/legal#terms">Terms</RouterLink></li>
          </ul>
        </div>
        <div>
          <h4>Contact</h4>
          <ul>
            <li>
              <a :href="`mailto:${SITE.contactEmail}`">{{ SITE.contactEmail }}</a>
            </li>
            <li><a :href="SITE.twitter" rel="noopener noreferrer">Twitter / X</a></li>
            <li><a :href="SITE.github" rel="noopener noreferrer">GitHub</a></li>
          </ul>
        </div>
      </div>
    </div>

    <div class="container site-footer-bottom">
      <span class="muted small">© {{ SITE.year }} {{ SITE.name }}. All rights reserved.</span>
      <span class="muted small">
        Trading involves risk. {{ SITE.name }} does not provide investment advice.
      </span>
    </div>
  </footer>
</template>

<script setup>
import BrandMark from './BrandMark.vue';
import SmartCta from './SmartCta.vue';
import { FORGOT_PASSWORD_URL, SITE } from '../config/site.js';
</script>

<style scoped>
.site-footer {
  margin-top: 0;
  padding: 56px 0 24px;
  border-top: 1px solid var(--border);
  background: var(--bg-elev);
}
.site-footer-grid {
  display: grid;
  grid-template-columns: 1.2fr 2.8fr;
  gap: 56px;
}
.site-footer-tag {
  margin: 12px 0 6px;
}
.site-footer-cols {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 32px;
}
.site-footer-cols h4 {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--muted-2);
  margin-bottom: 12px;
  font-weight: 600;
}
.site-footer-cols ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.site-footer-cols a,
.site-footer-cols :deep(.footer-link) {
  color: var(--fg-soft);
  font-size: 14px;
  text-decoration: none;
  background: none;
  border: none;
  padding: 0;
  border-radius: 0;
  font-weight: 400;
}
.site-footer-cols a:hover,
.site-footer-cols :deep(.footer-link:hover) {
  color: var(--accent);
}
.site-footer-bottom {
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid var(--border);
  display: flex;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.small {
  font-size: 12px;
}

@media (max-width: 880px) {
  .site-footer-grid {
    grid-template-columns: 1fr;
    gap: 32px;
  }
  .site-footer-cols {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }
}
</style>
